import { Directive, Input, OnInit, WritableSignal, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

import { DestroyableDirective } from '@shared/directive/destroyable.directive';
import { IOfficeField } from '@pages/office/models/office-data.model';
import { FormHelper } from '../../../shared/helpers/form.helper';
import { ControlErrorsMessagesOverridesRegistryModel } from './control-errors/models/control-custom-errors.model';
import { OfficeFormHelperService } from '../office-form-helper.service';
import { FormControlConfig } from './models/form-control-config.model';
import { ControlLabelAlignment } from '@pages/office/SingleGridForm/office-form/form-controls/control-wrapper/models/control-wrapper.models';

@Directive()
export class BaseFormControlDirective extends DestroyableDirective implements OnInit {
  @Input({ required: true }) officeField: IOfficeField;
  @Input({ required: true }) controlName: string;
  @Input({ required: true }) formGroupInstance: FormGroup;
  @Input() errorsMessagesOverridesRegistry: ControlErrorsMessagesOverridesRegistryModel;
  @Input() alignment: ControlLabelAlignment;
  @Input() config: FormControlConfig = {};

  readonly formHelperService = inject(OfficeFormHelperService);

  public control: FormControl;
  public disabled$: Observable<boolean>;
  public isTouched$: Observable<boolean>;
  public isDirty$: Observable<boolean>;
  public validating$: WritableSignal<boolean>;
  public invalid$: Observable<boolean>;

  ngOnInit(): void {
    this.control = this.formGroupInstance.get([this.controlName]) as FormControl;
    this.validating$ = this.formHelperService.validating$;
    this.defineControlRelatedStreams();
  }

  private defineControlRelatedStreams(): void {
    this.disabled$ = FormHelper.getControlDisabledStatus(this.control);
    this.invalid$ = FormHelper.getControlInvalidStatus(this.control);
    this.isTouched$ = FormHelper.isTouched(this.control);
    this.isDirty$ = FormHelper.isDirty(this.control);
  }
}
